import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';
import getMultiOption from 'editor/src/store/variants/helpers/getMultiOption';
import { ProductControlMulti } from 'editor/src/store/variants/types';

import updateMultiOptionsOperation from './updateMultiOptionsOperation';

const selectAllMultiOptionsOperation =
  (productControl: ProductControlMulti, availableOptions?: Set<string>) =>
  (dispatch: ThunkDispatch, getState: () => RootState) => {
    const state = getState();
    const variantState = state.variants;
    const { configuration, product, selectedSingleOptions } = variantState;

    if (configuration.singleSelection) {
      throw new Error('singleSelection configuration is not applicable to select all operation');
    }

    let { options } = productControl;
    if (availableOptions) {
      options = options.filter((option) => availableOptions.has(option.value));
    }

    let optionsValues = options.map((controlOption) =>
      getMultiOption(
        controlOption.value,
        product,
        selectedSingleOptions,
        !configuration.singleSelection && productControl.dependsOnSingleControls,
      ),
    );

    if (variantState.selectedMultiOptions[productControl.key]?.length) {
      optionsValues.push(...variantState.selectedMultiOptions[productControl.key]);

      const seen = new Set();
      optionsValues = optionsValues.filter((item) => {
        const serialized = JSON.stringify(item);
        if (seen.has(serialized)) {
          return false;
        }

        seen.add(serialized);
        return true;
      });
    }

    const multiOptions = {
      ...variantState.selectedMultiOptions,
      ...{ [productControl.key]: optionsValues },
    };

    dispatch(updateMultiOptionsOperation(multiOptions));
  };

export default selectAllMultiOptionsOperation;
